import { SettingsButton } from 'components/CantileverButton'
import { PageHeaderWithIcon } from 'components/PageHeaderWithIcon'
import { TextSearch } from 'lucide-react'
import { FC } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const APP_TITLE = 'Prism'

const LOW_OPACITY_DARK_BLUE = 'rgba(10,111,219, 0.15)'
const LOW_OPACITY_LIGHT_BLUE = 'rgba(159,225,255, 0.6)'
const PRISM_HEADER_COLOR = CantileverTheme.colors.grayscale[600]

const OuterHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 0.625rem;
  background-color: ${PRISM_HEADER_COLOR};
`

const InnerHeaderContainer = styled.div`
  width: 100%;
`

type ObjectViewPageHeaderProps = {
  handleSettingsClick?: () => void
  subtitle?: string
}

export const ObjectViewPageHeader: FC<ObjectViewPageHeaderProps> = ({
  handleSettingsClick,
  subtitle,
}) => {
  return (
    <OuterHeaderContainer>
      <InnerHeaderContainer>
        <PageHeaderWithIcon
          title={APP_TITLE}
          subtitle={subtitle}
          icon={
            <TextSearch
              size={27}
              strokeWidth={2}
              color={LOW_OPACITY_LIGHT_BLUE}
            />
          }
          iconBackgroundColor={LOW_OPACITY_DARK_BLUE}
          trailingContent={
            handleSettingsClick ? (
              <SettingsButton title='Settings' onClick={handleSettingsClick} />
            ) : undefined
          }
        />
      </InnerHeaderContainer>
    </OuterHeaderContainer>
  )
}

export default ObjectViewPageHeader
